import { useEffect, useState } from "react";
import { IoReceiptOutline } from "react-icons/io5";
import DescriptionList from "./../../../../../components/common/DescriptionList";
import Modal from "./../../../../../components/common/Modal";
import TaxpayerForm from "./TaxpayerForm";
import taxService from "./../../../../../services/taxService";

const TaxpayerInformation = ({ id }) => {
  const [taxpayer, setTaxpayer] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchTaxpayer = async () => {
      setIsLoading(true);
      const result = await taxService.getTaxpayerInfoAsync(id);

      if (mounted) {
        if (result) setTaxpayer(result);
        setIsLoading(false);
      }
    };

    if (id) fetchTaxpayer();

    return () => {
      mounted = false;
    };
  }, [id, refresh]);

  const number = taxpayer.number ?? "-";
  const rdo = taxpayer.revenue_district_office ?? "-";
  const address = taxpayer.registered_address ?? "-";

  const handleSuccess = () => {
    setShowForm(false);
    setRefresh(!refresh);
  };

  return (
    <div className="p-5">
      <div className="mt-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <IoReceiptOutline className="mr-3 text-3xl text-gray-300" />
            <div>
              <p className="text-gray-500">Taxpayer Information</p>
              <span className="text-xs text-gray-400">
                Taxpayer Identification
              </span>
            </div>
          </div>
          <button
            className="text-blue-500 text-sm"
            onClick={() => setShowForm(true)}
          >
            Edit
          </button>
        </div>
      </div>
      <div className="px-12 py-5 mt-5 space-y-7">
        <div className="grid grid-cols-2">
          <DescriptionList
            label="Taxpayer Identification No."
            className="col-span-2 sm:col-span-1"
            content={number}
            isLoading={isLoading}
          />
          <DescriptionList
            label="Revenue District Office"
            className="col-span-2 sm:col-span-1"
            content={rdo}
            isLoading={isLoading}
          />
        </div>
        <div className="grid grid-cols-2">
          <DescriptionList
            label="Registered Address"
            className="col-span-2"
            content={address}
            isLoading={isLoading}
          />
        </div>
      </div>
      <Modal
        title="Taxpayer Identification"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <TaxpayerForm
          id={id}
          data={taxpayer}
          isLoading={isFormLoading}
          setLoading={(value) => setIsFormLoading(value)}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default TaxpayerInformation;
